module.exports = __webpack_public_path__ + "img/success-in.c9159031.png";